<style>
.el-tabs__nav-wrap:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 98.5%;
  height: 2px;
  background-color: #e4e7ed;
  z-index: 1;
}
</style>
<style scoped="scoped" lang="scss">
.hideFormItem {
  display: none !important;
}

.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  height: 100%;
  min-width: 500px;

  // 隐藏表单项
  .hideFormItem {
    display: none !important;
  }
}
</style>
<template>
  <div class="container" ref="container">
    <div>
      <el-tabs v-model="activeName">
        <!-- 生产报表 -->
        <el-tab-pane :label="$t('shengchanbaobiao')" name="six"></el-tab-pane>
        <!-- 生产报表分析 -->
        <el-tab-pane :label="$t('shengchanbaobiaofenxi')" name="seven">
          <div>
            <production_report_analysis></production_report_analysis>
          </div>
        </el-tab-pane>
        <!-- 生产效率 -->
        <el-tab-pane :label="$t('shengchanxiaolv')" name="first">
          <div>
            <productivity></productivity>
          </div>
        </el-tab-pane>
        <!-- 生产合格率 -->
        <el-tab-pane :label="$t('shengchanhegelv')" name="second">
          <div>
            <production_qualification></production_qualification>
          </div>
        </el-tab-pane>
        <!-- 生产稼动率 -->
        <el-tab-pane :label="$t('shengchanjiadonglv')" name="three" lazy>
          <div v-if="containerHeight != 0" :style="{ height: containerHeight + 'px' }">
            <production_operation></production_operation>
          </div>
        </el-tab-pane>
        <!-- 生产订单完成情况 -->
        <el-tab-pane :label="$t('shengchandingdanwanchengqingkuang')" name="four"></el-tab-pane>
        <!-- 计划完成差异情况 -->
        <el-tab-pane :label="$t('jihuawanchengchayiqingkuang')" name="five"></el-tab-pane>
      </el-tabs>
      <div class="dialog-scroller" sytle="background:red">
        <production_order_completion v-if="activeName === 'four'"></production_order_completion>
        <plan_finish_difference v-if="activeName === 'five'"></plan_finish_difference>
        <production_report v-if="activeName === 'six'"></production_report>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import productivity from './tab/productivity.vue';
import production_order_completion from './tab/production_order_completion.vue';
import plan_finish_difference from './tab/plan_finish_difference.vue';
import production_qualification from './tab/production_qualification.vue';
import production_operation from './tab/production_operation.vue';
import production_report from './tab/production_report.vue';
import production_report_analysis from './tab/production_report_analysis.vue'
export default {
  name: 'web_customize_zhongshuo_report_produce_report_list',
  components: {
    productivity,
    production_qualification,
    production_operation,
    production_order_completion,
    plan_finish_difference,
    production_report,
    production_report_analysis
  },
  data() {
    return {
      containerHeight: 0,
      activeName: 'first'
    };
  },

  mounted() {
    setTimeout(() => {
      this.containerHeight = this.$refs.container.offsetHeight - 40 - 15;
    }, 300);
  },
  methods: {}
};
</script>
